import { React, Input, Button, Heading, Row, Col, Text, Shortcut } from "mondrian-react";
import { useEffect } from "react";
import { ReCaptcha } from "react-recaptcha-v3";
import { reportGA4, reportPageViewGA4 } from "utils/pushDataLayer";
import { logger } from "utils/logger";
import useIsTotem from 'hooks/useIsTotem';

import "./styles.scss";

const PhoneStep = ({
  propsLineNumber,
  propsButtonSubmit,
  recaptchaRef,
  verifyCallback,
}) => {
  useEffect(() => {
    reportPageViewGA4({customTitle: 'validacao_do_numero'})
  }, [])
  const isTotem = useIsTotem();

  return (
    <>
      <Row>
        <Col xs={12} lg={10} className="mdn-Offset-lg-1">
          <Heading xs className="mcm-StepTitle">
            Informe o número do titular da linha
          </Heading>      
        </Col>
        <Col xs={9} lg={3} className="mdn-Offset-lg-1">
          <Input
            phone
            autoFocus
            {...propsLineNumber}
            className="msisdn"
            errorMessage="Insira um celular válido!"
            aria-label="Insira o DDD junto com o número do telefone"
          >
            DDD + Celular
          </Input>
          <ReCaptcha
            ref={recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA_CLIENT}
            verifyCallback={verifyCallback}
          />
        </Col>
        <Col xs={12} lg={2} className="mdn-u-flex mdn-u-justifyContent-lg-end mdn-u-alignItems-xs-center">
          <Button {...propsButtonSubmit}>Continuar</Button>
        </Col>
      </Row>
      {!isTotem &&
        <Row className="payment-section">
          <Col xs={12}>
            <Heading sm className="heading">
              Precisa de ajuda para realizar o pagamento?
            </Heading>
            <Text className="mdn-Text mdn-Text--body subtitle">
              Facilite o pagamento de suas dívidas e regularize suas pendências com a Claro.
            </Text>
            <div className="">
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectClaroNegocie" });
                  reportGA4({customTitle: 'validacao_do_numero:claro-negocie'})
                }}
                href="https://claronegocie.com.br/login"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-claro mdn-Icon--md"}
                target="_blank"
              >
                Claro negocie
              </Shortcut>
              <Shortcut
                onClick={() => {
                  logger({ name: "RedirectClaroEmpresas" });
                  reportGA4({customTitle: 'validacao_do_numero:claro-empresas'})
                }}
                href="https://minhaclaroempresas.claro.com.br/#AutenticacaoUsuario"
                className="card1"
                icon={"mdn-Shortcut-icon mdn-Icon-empresa mdn-Icon--md"}
                inverse
                target="_blank"
              >
                Claro <br />empresas
              </Shortcut>
            </div>
          </Col>
        </Row>
      }
    </>
  );
};
export default PhoneStep;
